/*=========================================================================================
  File Name: moduleEcommerceState.js
  Description: Ecommerce Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

/* eslint-disable */
export default {
    empresas: [],
    paramsCompany: [],
    claseState: [],
    zonaState: [],
    countItems: 0, 
    cItemView: '', 
    clipsw: '', 
    cartItems: [],
    wishList: [],
    clientState: [],
    productState: [],
    total_pages: 0,
    lispreState: 1,
    desartState: 0,
    descliState: 0,
    ruccedState: localStorage.getItem("rucced"),
    codempState: localStorage.getItem("codemp"),
    paramState: JSON.parse(localStorage.getItem("parcli")),
    orderState: [],
    subTotalState: 0,
    descuentoState: 0,
    totalNetoState: 0,
    grabaIvaState: 0,
    noGrabaIvaState: 0,
    ivaState: 0,
    totalState: 0,
    pedidoState: {},
    historialPedidos: [],
    pedidoSeleccionado: [],
    cuentasCobrarState: [],
    itemsPageState: null
}
/* eslint-enable */
